/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordResetAttestationData
 */
export interface PasswordResetAttestationData {
    /**
     * 
     * @type {string}
     * @memberof PasswordResetAttestationData
     */
    password: string;
}

/**
 * Check if a given object implements the PasswordResetAttestationData interface.
 */
export function instanceOfPasswordResetAttestationData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function PasswordResetAttestationDataFromJSON(json: any): PasswordResetAttestationData {
    return PasswordResetAttestationDataFromJSONTyped(json, false);
}

export function PasswordResetAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordResetAttestationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function PasswordResetAttestationDataToJSON(value?: PasswordResetAttestationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

